// ============================================================================
//  Synchronisation hors-ligne (techniciens sans réseau).
//  - Cache local des interventions (lecture offline).
//  - File d'attente des écritures (création / mise à jour de rapports) qui
//    part vers Supabase dès que le réseau revient.
//  Volontairement sans dépendance : localStorage + supabase passé en argument.
// ============================================================================

const QUEUE_KEY = 'planifpro_offline_queue';
const CACHE_KEY = 'planifpro_interventions_cache';

// ---- Cache lecture (interventions) ----------------------------------------
export function cacheInterventions(list) {
  try { localStorage.setItem(CACHE_KEY, JSON.stringify(list || [])); } catch (_) {}
}
export function getCachedInterventions() {
  try { return JSON.parse(localStorage.getItem(CACHE_KEY) || '[]'); } catch (_) { return []; }
}

// ---- File d'attente écriture ----------------------------------------------
export function getQueue() {
  try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]'); } catch (_) { return []; }
}
function setQueue(q) {
  try { localStorage.setItem(QUEUE_KEY, JSON.stringify(q)); } catch (_) {}
}
export function queueCount() { return getQueue().length; }

export function newTempId() {
  return 'local-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7);
}

// Ajoute une opération à synchroniser plus tard
export function queueOp(op) {
  const q = getQueue();
  q.push(op);
  setQueue(q);
  return q.length;
}

// ---- Synchronisation : vide la file vers Supabase --------------------------
// Retourne { synced, remaining, idMap }. idMap : tempId -> id réel (après insert).
export async function flushQueue(supabase) {
  const q = getQueue();
  if (q.length === 0) return { synced: 0, remaining: 0, idMap: {} };

  const idMap = {};
  const remaining = [];
  let synced = 0;

  for (const op of q) {
    try {
      if (op.kind === 'create') {
        const { data, error } = await supabase.from(op.table).insert([op.data]).select();
        if (error) throw error;
        if (data && data[0]) idMap[op.tempId] = data[0].id;
        synced++;
      } else if (op.kind === 'update') {
        // Si la ligne vient d'une création offline encore non synchronisée,
        // on résout son id réel via idMap (sinon on réessaiera plus tard).
        const realId = String(op.id).startsWith('local-') ? idMap[op.id] : op.id;
        if (!realId) { remaining.push(op); continue; }
        const { error } = await supabase.from(op.table).update(op.data).eq('id', realId);
        if (error) throw error;
        synced++;
      } else if (op.kind === 'delete') {
        const realId = String(op.id).startsWith('local-') ? idMap[op.id] : op.id;
        if (realId) {
          const { error } = await supabase.from(op.table).delete().eq('id', realId);
          if (error) throw error;
        }
        synced++;
      }
    } catch (_) {
      remaining.push(op); // on garde pour un prochain essai
    }
  }

  setQueue(remaining);
  return { synced, remaining: remaining.length, idMap };
}
